import digitalData from "digital-data";
import { OVERLAY, BUTTON_SUBMISSION } from "../constants";

export const manageUsers = () => {
  const trackEvent = (event) => {
    digitalData.event = digitalData.event || [];
    digitalData.event.push(event);
  };

  const manageUsersEvents = {
    drawerOverlay: ({ output }) => {
      const step = output?.step;
      const DDOEvent = {
        category: {
          primaryCategory: OVERLAY,
        },
        eventInfo: {
          eventName: `user management: ${step}`,
        },
      };
      trackEvent(DDOEvent);
    },
    selectedCreditCards: ({ output }) => {
      // Format card types and counts into a string (e.g., "MA>5,DISC>3,VISA>2")
      const cardEntries = Object.entries(output || {});
      const cardDetails =
        cardEntries.length > 0
          ? cardEntries.map(([cardType, count]) => `${cardType}>${count}`).join(",")
          : "none shared";

      const DDOEvent = {
        category: {
          primaryCategory: BUTTON_SUBMISSION,
        },
        eventInfo: {
          eventName: `my account settings`,
        },
        myAccount: {
          settings: `user management: credit cards overlay: apply: ${cardDetails}`,
        },
      };
      trackEvent(DDOEvent);
    },
    editSelectedPaymentPermissions: ({ output }) => {
      const role = output?.role?.toLowerCase();
      const ccPermissions = output?.ccPermissions;
      const pTCPermissions = output?.pTCPermissions;

      const formatPermissions = (cc, ptc) => {
        const parts = [];
        if (cc !== undefined && cc !== null && cc !== 0) parts.push(`cc>${cc}`);
        if (ptc !== undefined && ptc !== null && ptc !== 0) parts.push(`ptc>${ptc}`);
        return parts.length > 0 ? parts.join(",") : "";
      };

      const permissionsString = formatPermissions(ccPermissions, pTCPermissions);

      const DDOEvent = {
        category: {
          primaryCategory: BUTTON_SUBMISSION,
        },
        eventInfo: {
          eventName: `my account settings`,
        },
        myAccount: {
          settings: `user management: edit user: type>${role}${permissionsString ? `: ${permissionsString}` : ""}`,
        },
      };
      trackEvent(DDOEvent);
    },
    cancelClick: ({ output }) => {
      const step = output?.step;
      const DDOEvent = {
        category: {
          primaryCategory: BUTTON_SUBMISSION,
        },
        eventInfo: {
          eventName: `my account settings`,
        },
        myAccount: {
          settings: `user management flow: ${step} overlay: cancel`,
        },
      };
      trackEvent(DDOEvent);
    },
    addUserSuccess: ({ output }) => {
      const role = output?.role?.toLowerCase();
      const ccPermissions = output?.ccPermissions;
      const pTCPermissions = output?.pTCPermissions;

      const formatPermissions = (cc, ptc) => {
        const hasCC = cc !== undefined && cc !== null && cc !== 0;
        const hasPTC = ptc !== undefined && ptc !== null && ptc !== 0;
        const parts = [];
        if (hasCC) parts.push(`cc>${cc}`);
        if (hasPTC) parts.push(`ptc>${ptc}`);
        return parts.length > 0 ? parts.join(",") : "";
      };

      const permissionsString = formatPermissions(ccPermissions, pTCPermissions);

      const DDOEvent = {
        category: {
          primaryCategory: BUTTON_SUBMISSION,
        },
        eventInfo: {
          eventName: `my account settings`,
        },
        myAccount: {
          settings: permissionsString
            ? `user management: add user: ${role}: yes: ${permissionsString}`
            : `user management: add user: ${role}: no`,
        },
      };
      trackEvent(DDOEvent);
    },
    linkClick: ({ output }) => {
      const linkName = output?.linkName;
      const DDOEvent = {
        category: {
          primaryCategory: BUTTON_SUBMISSION,
        },
        eventInfo: {
          eventName: `my account settings`,
        },
        myAccount: {
          settings: `user management: ${linkName} link`,
        },
      };
      trackEvent(DDOEvent);
    },
  };

  window.LIFE_CYCLE_EVENT_BUS.on("manage-users.drawer-overlay", manageUsersEvents.drawerOverlay);
  window.LIFE_CYCLE_EVENT_BUS.on(
    "manage-users.selected-credit-cards",
    manageUsersEvents.selectedCreditCards,
  );
  window.LIFE_CYCLE_EVENT_BUS.on(
    "manage-users.edit-selected-payment-permissions",
    manageUsersEvents.editSelectedPaymentPermissions,
  );
  window.LIFE_CYCLE_EVENT_BUS.on("manage-users.cancel-click", manageUsersEvents.cancelClick);
  window.LIFE_CYCLE_EVENT_BUS.on("manage-users.add-user-success", manageUsersEvents.addUserSuccess);
  window.LIFE_CYCLE_EVENT_BUS.on("manage-users.link-click", manageUsersEvents.linkClick);
};
